/**
 * The coaching card's query keys, in a module of their own so the roadmap hooks can invalidate
 * the card (an answer on the roadmap page moves the current move, F-131 alignment D1) without
 * importing `use-current-move`, which imports them back.
 */

export const currentMoveQueryKey = (organizationId: string | null) =>
  ['coaching', 'current-move', organizationId] as const;
